var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import iconSizes from '../../iconSizes';
/**
 * CheckIcon
 */
var CheckIcon = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'm' : _c, _d = _a.color, color = _d === void 0 ? 'black' : _d, title = _a.title;
    return (_jsxs("svg", __assign({ focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: '0 0 32 32', style: { width: iconSizes[size], height: iconSizes[size] }, role: "img", "aria-hidden": (_b = !title) !== null && _b !== void 0 ? _b : false }, { children: [title && _jsx("title", { children: title }, void 0),
            _jsx("g", __assign({ style: { fill: color } }, { children: _jsxs("svg", __assign({ viewBox: "0 0 24 24" }, { children: [_jsx("path", { d: "M20.7 5.3c-.4-.4-1-.4-1.4 0L9 15.6l-4.3-4.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l5 5c.2.2.4.3.7.3.3 0 .5-.1.7-.3l11-11c.4-.4.4-1 0-1.4z" }, void 0),
                        _jsxs("g", __assign({ fillRule: "evenodd" }, { children: [_jsx("use", {}, void 0),
                                _jsx("use", { fillRule: "nonzero" }, void 0)] }), void 0)] }), void 0) }), void 0)] }), void 0));
};
export default CheckIcon;
